/**
 * From:
 * https://www.learningsomethingnew.com/how-to-solve-an-invalid-or-illegal-string-was-specified-error-with-svelte-3-and-cordova
 * Basically svelte has this: mo.insertRule("@keyframes "
 * Needs to be mo.insertRule("@-webkit-keyframes " for older chrome
 */
(function () {
    if (!(CSSStyleSheet && CSSStyleSheet.prototype.insertRule)) {
        return;
    }

    var style = document.createElement('style');
    var shouldPrefixKeyframes = false;

    document.body.appendChild(style);

    try {
        style.sheet.insertRule('@keyframes _ {}', 0);
    } catch (err) {
        shouldPrefixKeyframes = true;
    }

    document.body.removeChild(style);

    if (!shouldPrefixKeyframes) {
        return;
    }

    var originalInsertRule = CSSStyleSheet.prototype.insertRule;

    CSSStyleSheet.prototype.insertRule = function (rule, index) {
        if (rule.indexOf('@keyframes') === 0) {
            rule = rule.replace('@keyframes', '@-webkit-keyframes');

            try {
                originalInsertRule.call(this, rule, index);
            } catch (err) {}
        } else {
            originalInsertRule.call(this, rule, index);
        }
    };
})();
